import { takeLatest, put, call, all } from 'redux-saga/effects';
import { updateCartItem } from 'yoda-interfaces/lib/Cart/CartApi';
import showGlobalLoader from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import {
    ITEM_FULFILLMENT_UPDATE_REQUEST,
    CART_DETAILS_GET_REQUEST,
    ITEM_FULFILLMENT_UPDATE_ERROR,
    UPDATE_ANALYTICS_CLICK_EVENT,
} from '../actionTypes/CartActionTypes';
import { updateCartItemInit } from '../actions/CartItemsAction';

function* itemFulfillmentUpdateSaga(action) {
    try {
        yield put(updateCartItemInit(action.payload.id));
        const result = yield call(FactorySaga, updateCartItem, action);
        // Make the get cart call to refresh the items
        if (result.isSuccess) {
            yield all([
                put({ type: UPDATE_ANALYTICS_CLICK_EVENT, payload: action.payload }),
                put({ type: CART_DETAILS_GET_REQUEST, productId: action.payload.id }),
            ]);
        } else {
            yield put(showGlobalLoader(false));
        }
    } catch (error) {
        yield all([
            // Need to show appropriate error in this case
            put({ type: ITEM_FULFILLMENT_UPDATE_ERROR, error }),
            put(showGlobalLoader(false)),
        ]);
    }
}

const watchItemFulfillmentUpdate = function* watchItemFulfillmentUpdate() {
    yield takeLatest(ITEM_FULFILLMENT_UPDATE_REQUEST, itemFulfillmentUpdateSaga);
};
watchItemFulfillmentUpdate.sagaName = 'watchItemFulfillmentUpdate';

export default watchItemFulfillmentUpdate;
